'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CallbackQueue = require('react/lib/CallbackQueue');

var _CallbackQueue2 = _interopRequireDefault(_CallbackQueue);

var _PooledClass = require('react/lib/PooledClass');

var _PooledClass2 = _interopRequireDefault(_PooledClass);

var _Transaction = require('react/lib/Transaction');

var _Transaction2 = _interopRequireDefault(_Transaction);

var _ReactUpdateQueue = require('react/lib/ReactUpdateQueue');

var _ReactUpdateQueue2 = _interopRequireDefault(_ReactUpdateQueue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ON_KONSUL_READY_QUEUEING = {
  initialize: function initialize() {
    this.reactMountReady.reset();
  },
  close: function close() {
    this.reactMountReady.notifyAll();
  }
};

function ReactKonsulReconcileTransaction() {
  this.reinitializeTransaction();
  this.reactMountReady = _CallbackQueue2.default.getPooled(null);
}

var Mixin = {
  getTransactionWrappers: function getTransactionWrappers() {
    return [ON_KONSUL_READY_QUEUEING];
  },
  getReactMountReady: function getReactMountReady() {
    return this.reactMountReady;
  },
  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function getUpdateQueue() {
    return _ReactUpdateQueue2.default;
  },
  destructor: function destructor() {
    _CallbackQueue2.default.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

Object.assign(ReactKonsulReconcileTransaction.prototype, _Transaction2.default.Mixin, Mixin);

_PooledClass2.default.addPoolingTo(ReactKonsulReconcileTransaction);

exports.default = ReactKonsulReconcileTransaction;


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/reconcileTransaction.js
// module id = 682
// module chunks = 0